<template>
    <v-app>
        <v-dialog
            v-model="$store.getters['CreateAudienceStore/getSchedulerEditModalStatus']"
            persistent
            fullscreen
            hide-overlay
            transition="slide-x-reverse-transition"
            scrollable
            :content-class="isMobile"
        >
            <v-card tile>
                <v-toolbar
                    flat
                    dark
                    color="primary"
                >
                    <v-toolbar-title>Edit Scheduler</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn
                            icon
                            dark
                            @click="close()"
                        >
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-card-text>
                    <div class="card createActivation">
                        <div class="card-body">

                            <v-form ref="edit_scheduler">
                                <div class="row" v-if="message">
                                    <div class="col-12">
                                        <div class="alert alert-warning" role="alert">
                                            <i class="fas fa-exclamation-triangle mr-2"></i>
                                            <span>{{ message }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- Name -->
                                <div class="row">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Scheduler name.</span>
                                        </v-tooltip>

                                        <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> General</span>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <v-text-field
                                            v-model="name"
                                            label="Scheduler Name"
                                            :rules="[requiredField]"
                                            :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                            :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                        ></v-text-field>
                                    </div><!--form-group-->
                                </div>
                                <hr style="opacity: 0.3;">

                                <!-- Recurrences -->
                                <div class="row">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Custom recurrence settings for starting of the <br> automated process.</span>
                                        </v-tooltip>

                                        <i class="fas fa-sync-alt"></i> <span style="padding-left: 5px;"> Custom Recurrence</span>
                                    </div>
                                    <div class="col-10">
                                        <div class="d-flex flex-row">
                                            <div class="form-group mb-0">
                                                <span class="mt-7 d-inline-block">Analysis will start on </span>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0 mx-2">
                                                <div class="d-flex flex-row">
                                                    <v-menu
                                                        v-model="start_date_menu"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="auto"
                                                    >
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field
                                                                v-model="start_date"
                                                                class="custom-input"
                                                                v-bind="attrs"
                                                                v-on="on"
                                                                :rules="[requiredStartDate]"
                                                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            header-color="#fb7e42"
                                                            color="#fb7e42"
                                                            v-model="start_date"
                                                            @input="start_date_menu = false"
                                                            :min="today"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                    <span class="ml-1 mt-7 d-inline-block"> at </span>
                                                    <v-text-field
                                                        type="time"
                                                        v-model="time"
                                                        class="custom-input ml-2"
                                                        :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                        :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                    ></v-text-field>
                                                </div>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0">
                                                <span class="mt-7 d-inline-block">and repeat on a</span>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0 mx-2">
                                                <v-autocomplete
                                                    class="custom-input"
                                                    v-model="act_frequency"
                                                    :items="repeat_options"
                                                    :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                    :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                ></v-autocomplete>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0">
                                                <span class="mt-7 d-inline-block">basis.</span>
                                            </div><!--form-group-->
                                        </div>

                                        <div class="d-flex flex-row">
                                            <div class="form-group mb-0">
                                                <span class="mt-7 d-inline-block">Analyze signals for </span>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0 mx-2">
                                                <v-autocomplete
                                                    class="custom-input"
                                                    v-model="recurrence_type"
                                                    :items="recurrence_types"
                                                    :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                    :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                ></v-autocomplete>
                                            </div><!--form-group-->
                                            <div class="form-group mb-0" v-if="recurrence_type === 3">
                                                <v-text-field
                                                    type="number"
                                                    v-model="period"
                                                    class="custom-input"
                                                    :rules="[periodValue]"
                                                    @change="setDynamicDate"
                                                    :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                    :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                ></v-text-field>
                                            </div>
                                            <div class="form-group mb-0 ml-2" v-if="recurrence_type === 3">
                                                <span class="mt-7 d-inline-block">days backwards.</span>
                                            </div><!--form-group-->
                                        </div>
                                        <div v-if="recurrence_type === 3 && act_frequency === 'daily'" class="d-flex flex-row">
                                                <span class="alert alert-info">
                                                    Please note that the generated POI data is delayed by 72 hours. As a result, <strong>{{ dynamic_date }}</strong> will be the first processing day.
                                                </span>
                                        </div>
                                        <div v-if="recurrence_type === 2 && Number(start_date.slice(-2)) < 4" class="d-flex flex-row">
                                                <span class="alert alert-info">
                                                    Please note that the generated POI data is delayed by 72 hours. As a result, selected date to run should be after 3rd in month.
                                                </span>
                                        </div>
                                    </div>
                                </div>
                                <hr style="opacity: 0.3;">

                                <!-- Ending -->
                                <div class="row">
                                    <div class="form-inline col-md-2">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn
                                                    icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon color="grey lighten-1" class="tooltip-small">
                                                        mdi-information-outline
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Setting under which conditions the automated process <br> should be completed.</span>
                                        </v-tooltip>

                                        <i class="fas fa-hourglass-end"></i> <span style="padding-left: 5px;"> Expire</span>
                                    </div>
                                    <div class="col-10">
                                        <div class="row">
                                            <div class="col-3">
                                                <div class="d-flex flex-row">
                                                    <div class="form-group mb-0 ending-type">
                                                        <v-radio-group
                                                            v-model="ending_type"
                                                            :rules="[requiredField]"
                                                        >
                                                            <v-radio
                                                                v-for="item in ending_types"
                                                                :key="item.value"
                                                                :label="item.text"
                                                                :value="item.value"
                                                                :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                                :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                            ></v-radio>
                                                        </v-radio-group>
                                                    </div><!--form-group-->
                                                </div>
                                            </div>
                                            <div class="col-4" v-if="ending_type === ending_types[1].value">
                                                <div class="d-flex flex-row">
                                                    <div class="form-group mb-0">
                                                        <span class="mt-7 d-inline-block">After</span>
                                                    </div><!--form-group-->
                                                    <div class="form-group mb-0 mx-2">
                                                        <v-text-field
                                                            type="number"
                                                            v-model="recurrences"
                                                            class="custom-input"
                                                            :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                            :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                        ></v-text-field>
                                                    </div><!--form-group-->
                                                    <div class="form-group mb-0">
                                                        <span class="mt-7 d-inline-block">recurrences</span>
                                                    </div><!--form-group-->
                                                </div>
                                            </div>
                                            <div class="col-4 mt-2" v-if="ending_type === ending_types[2].value">
                                                <div class="d-flex flex-row">
                                                    <div class="form-group mb-0">
                                                        <v-menu
                                                            v-model="end_date_menu"
                                                            :close-on-content-click="false"
                                                            :nudge-right="40"
                                                            transition="scale-transition"
                                                            offset-y
                                                            min-width="auto"
                                                        >
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-text-field
                                                                    v-model="end_date"
                                                                    class="custom-input"
                                                                    v-bind="attrs"
                                                                    label="End Date"
                                                                    v-on="on"
                                                                    :rules="[requiredEndDate]"
                                                                    :disabled="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                                    :loading="$store.getters['CreateAudienceStore/isFieldLoadingStatus']('scheduler_edit_fields')"
                                                                ></v-text-field>
                                                            </template>
                                                            <v-date-picker
                                                                header-color="#fb7e42"
                                                                color="#fb7e42"
                                                                v-model="end_date"
                                                                @input="end_date_menu = false"
                                                                :min="today"
                                                            ></v-date-picker>
                                                        </v-menu>
                                                    </div><!--form-group-->
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-form>

                            <hr>
                            <div class="row">
                                <div class="col-1 text-left">
                                    <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                                </div>
                                <div class="col-1 text-right offset-10">
                                    <button @click.prevent="submitData()" class="btn btn-success">Update</button>
                                </div>
                            </div>
                        </div>
                    </div><!--card-->
                </v-card-text>
                <div style="flex: 1 1 auto;"></div>
            </v-card>
        </v-dialog>
    </v-app>
</template>

<script>
import Modal from '../Modal'
import analyses from "../../mixin/analyses";

export default {
    name: "EditExistingScheduler",
    components: {
        Modal,
    },
    data: () => ({
        start_date_menu: false,
        end_date_menu: false,
        repeat_options: [
            {
                value: 'daily',
                text: 'Daily'
            },
            {
                value: 'weekly',
                text: 'Weekly'
            },
            {
                value: 'bi-weekly',
                text: 'Bi-Weekly'
            },
            {
                value: 'monthly',
                text: 'Monthly'
            },
        ],
        recurrence_types: [
            {
                value: 1,
                text: 'Last Week'
            },
            {
                value: 2,
                text: 'Last Month'
            },
            {
                value: 3,
                text: 'Custom'
            }
        ],
        ending_types: [
            {
                value: 1,
                text: 'Never'
            },
            {
                value: 2,
                text: 'Recurrences'
            },
            {
                value: 3,
                text: 'Custom Date'
            },
        ],

        dynamic_date: '',

        today: '',

        requiredAudience: v => v && v > 0 || 'Limit audience must be greater then 0',
        requiredField: v => v && true || 'This field is required',
        requiredFileField: v => v || 'This field is required',
        requiredPricingModel: v => v && v.length > 5 || 'Pricing model is required',
        requiredStartDate: v => v && v.length > 0 || 'Start Date field is required',
        requiredEndDate: v => v && v.length > 0 || 'End Date field is required',
    }),
    methods: {
        submitData() {
                if (this.$refs['edit_scheduler'].validate()) {
                    this.$store.dispatch('CreateAudienceStore/updateScheduler')
                }
        },
        close() {
            this.$store.commit('CreateAudienceStore/RESET_STATE')
            this.$store.commit('ActivateAudienceStore/RESET_STATE')
            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_EDIT_MODAL', false)
        },
        periodValue(v) {
            if (this.$store.getters['ActivateAudienceStore/getActivationAnalyses'].includes('anonymized')) {
                let date = new Date(this.$store.getters['CreateAudienceStore/getSchedulerStartDate'])
                let year = date.getFullYear()
                let month = date.getMonth()

                if (month === 1) {
                    year = year - 1
                    month = 12
                }

                let last_month_days = new Date(year, month, 0).getDate();
                let valid_days = last_month_days + date.getDate()

                if (v < valid_days) {
                    return true
                } else {
                    return 'Period must be lower then ' + valid_days + ' for this dataset'
                }
            } else {
                return true
            }
        },
        setDynamicDate() {
            const final_date = new Date(this.$store.getters['CreateAudienceStore/getSchedulerStartDate'])
            final_date.setDate(final_date.getDate() - 2 - this.period)
            this.dynamic_date = final_date.toJSON().slice(0, 10)
        },
    },
    created() {
        const date = new Date()
        let date_string = date.toJSON().slice(0, 10)
        let full_time = date_string + ' ' + this.timeNow + ':00'
        this.time = this.timeNow

        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_START_DATE', date_string)
        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)
        this.today = date_string
        this.$store.commit('CreateAudienceStore/SET_SCHEDULER_TIME_ZONE', this.timezone)
    },
    computed: {
        message() {
            return this.$store.getters['CreateAudienceStore/getSchedulerMessage']
        },
        name: {
            get() {
                return this.$store.getters['CreateAudienceStore/getActivationName']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_NAME', value)
            }
        },
        time: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerTime']
            },
            set(value) {
                let full_time = this.$store.getters['CreateAudienceStore/getSchedulerStartDate'] + ' ' + value + ':00'
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)

                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_TIME', value)
            }
        },
        start_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerStartDate']
            },
            set(value) {
                let full_time = value + ' ' + this.time + ':00'

                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_START_DATE', value)
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_FULL_TIME', full_time)
                this.setDynamicDate()
            }
        },
        end_date: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndDate']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_END_DATE', value)
            }
        },
        act_frequency: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerActivationFrequency']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ACTIVATION_FREQUENCY', value)
            }
        },
        recurrence_type: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerRecurrenceType']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_RECURRENCE_TYPE', value)
            }
        },
        ending_type: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndingType']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ENDING_TYPE', value)
            }
        },
        recurrences: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerEndingRecurrences']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_ENDING_RECURRENCES', value)
            }
        },
        period: {
            get() {
                return this.$store.getters['CreateAudienceStore/getSchedulerPeriod']
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_SCHEDULER_PERIOD', value)
            }
        }
    },
    watch: {
        act_frequency: function () {
            let period = 30
            if (this.act_frequency === 'daily') {
                period = 1
            } else if (this.act_frequency === 'monthly') {
                period = 30
            } else if (this.act_frequency === 'weekly') {
                period = 7
            } else if (this.act_frequency === 'bi-weekly') {
                period = 30
            }

            this.$store.commit('CreateAudienceStore/SET_SCHEDULER_PERIOD', period)
        },
    },
    mounted() {
        this.$store.dispatch('CreateAudienceStore/fetchEditingScheduler', this.$store.getters['CreateAudienceStore/getSchedulerEditingId'])
    }
}
</script>

<style type="scss">
.ending-type .v-input--radio-group__input .v-radio .v-input--selection-controls__input {
    display: block !important;
}

.custom-input .v-input__control .v-input__slot .v-text-field__slot input,
.custom-input .v-input__control .v-input__slot .v-select__slot input {
    text-align: center !important;
}

</style>